import { spinPrefixCls } from "@/base/components/index";
import { createStyles } from "antd-style";

export const useLoaderStyles = createStyles(({ token, css }: any) => ({
  root: css`
    .${spinPrefixCls}-fullscreen {
      z-index: ${token.zIndexHeader - 2};
    }
  `,
  spin: css``,
}));
